<section class="mt-2 pr-2">
    <h4>{{translate.getLng('SYS_ISSUER')}}</h4>
    <sen-app-customer-data (emitAddress)="emitAddress($event)" [type]="type" [data]="data"></sen-app-customer-data>
</section>